import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.jsx";

// Capture the install prompt as early as possible — before React mounts.
// The beforeinstallprompt event often fires before useEffect listeners are attached.
window.__pwaInstallPrompt = null;
window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault();
  window.__pwaInstallPrompt = e;
  window.dispatchEvent(new Event('pwaInstallPromptReady'));
}, { once: false });

window.addEventListener('appinstalled', () => {
  window.__pwaInstallPrompt = null;
});

import { Provider, ErrorBoundary } from '@rollbar/react';
import { rollbarConfig } from './config/rollbar';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      gcTime: 1000 * 60 * 30, // 30 minutes (was cacheTime)
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

createRoot(document.getElementById("root")).render(
  <Provider config={rollbarConfig}>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </ErrorBoundary>
  </Provider>
);
